module.exports = __webpack_public_path__ + "static/media/Tela_fundo_privacidade2.675c13db.svg";